/**
 * The Promo Codes routes, in one place so the list path and the
 * `/promo-codes/:campaignId` detail path are not spelled out as literals
 * across the table cells, the breadcrumb and the office tab. The `<Route>`
 * declarations in App.js stay literal — that is where the paths are defined.
 */
export const PROMO_CODES_PATH = '/promo-codes';

export const promoCodePath = (campaignId) => `${PROMO_CODES_PATH}/${campaignId}`;
